import React from 'react'

import { LntDivider } from '@app/components/base'

import styles from './styles.module.scss'

import type { SubheaderToolbarDividerProps } from './types'

export const SubheaderToolbarDivider: React.FC<SubheaderToolbarDividerProps> = props => {
  return (
    <LntDivider
      { ...props }
      removeMargins
      type='vertical'
      className={ styles.subheaderToolbarDivider }
    />
  )
}
